<app-nav-bar *ngIf="token && boardsLoaded"></app-nav-bar>
<router-outlet></router-outlet>